module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_7.4c382515.png";